import React, {useMemo} from "react";
import {css, Theme} from "@emotion/react";

import {p} from "@pg-design/helpers-css-strings";

import {HEADER_CELL_WIDTH, HEADER_CELL_WIDTH_MOBILE} from "../../constants/table_sizes";
import {IComparisonTableHeader, IComparisonTableHeaderObject} from "../../types/IComparisonTableHeader";
import {IComparisonTableStyleDefaults} from "../../types/IComparisonTableStyleDefaults";
import {RowHeaderIconWrap} from "./RowHeaderIcon";
import {RowHeaderTitle} from "./RowHeaderTitle";

interface IProps {
    height?: number;
    headerIconsSettings: IComparisonTableStyleDefaults["headerIcons"];
    headerDefinition: IComparisonTableHeader;
}

export const RowHeader = (props: IProps) => {
    const {height, headerDefinition} = props;

    const {component, onClick} = useMemo(() => {
        if (isHeaderDefinitionObject(headerDefinition)) {
            const {icon: RowHeaderIcon, label} = headerDefinition;
            return {
                component: (
                    <>
                        {RowHeaderIcon && (
                            <RowHeaderIconWrap iconSize={props.headerIconsSettings.size}>
                                <RowHeaderIcon size={props.headerIconsSettings.size} fill={props.headerIconsSettings.fill} />
                            </RowHeaderIconWrap>
                        )}
                        <RowHeaderTitle>{label}</RowHeaderTitle>
                    </>
                ),
                onClick: headerDefinition.onClick
            };
        }

        const HeaderComponent = headerDefinition;
        return {
            component: <HeaderComponent />
        };
    }, [headerDefinition]);

    return (
        <div css={headerColumnCell}>
            <span style={{height}} css={headerCell} onClick={onClick}>
                {component}
            </span>
        </div>
    );
};

RowHeader.IconWrapper = RowHeaderIconWrap;
RowHeader.Title = RowHeaderTitle;

const isHeaderDefinitionObject = (headerDefinition: IComparisonTableHeader): headerDefinition is IComparisonTableHeaderObject => {
    return "label" in headerDefinition && !!headerDefinition.label;
};

const headerColumnCell = css`
    display: flex;
    align-items: center;
    background-color: #fff;
    z-index: 2;
    user-select: none;
`;

const headerCell = (theme: Theme) => css`
    position: absolute;
    left: 0;
    ${p(1, 1, 1, 2)}
    width: ${HEADER_CELL_WIDTH_MOBILE};
    min-width: ${HEADER_CELL_WIDTH_MOBILE};
    display: flex;
    align-items: center;

    @media (min-width: ${theme.breakpoints.md}) {
        width: ${HEADER_CELL_WIDTH};
        min-width: ${HEADER_CELL_WIDTH};
    }
`;
import React, {useMemo} from "react";
import {css, Theme} from "@emotion/react";

import {p} from "@pg-design/helpers-css-strings";

import {HEADER_CELL_WIDTH, HEADER_CELL_WIDTH_MOBILE} from "../../constants/table_sizes";
import {IComparisonTableHeader, IComparisonTableHeaderObject} from "../../types/IComparisonTableHeader";
import {IComparisonTableStyleDefaults} from "../../types/IComparisonTableStyleDefaults";
import {RowHeaderIconWrap} from "./RowHeaderIcon";
import {RowHeaderTitle} from "./RowHeaderTitle";

interface IProps {
    height?: number;
    headerIconsSettings: IComparisonTableStyleDefaults["headerIcons"];
    headerDefinition: IComparisonTableHeader;
}

export const RowHeader = (props: IProps) => {
    const {height, headerDefinition} = props;

    const {component, onClick} = useMemo(() => {
        if (isHeaderDefinitionObject(headerDefinition)) {
            const {icon: RowHeaderIcon, label} = headerDefinition;
            return {
                component: (
                    <>
                        {RowHeaderIcon && (
                            <RowHeaderIconWrap iconSize={props.headerIconsSettings.size}>
                                <RowHeaderIcon size={props.headerIconsSettings.size} fill={props.headerIconsSettings.fill} />
                            </RowHeaderIconWrap>
                        )}
                        <RowHeaderTitle>{label}</RowHeaderTitle>
                    </>
                ),
                onClick: headerDefinition.onClick
            };
        }

        const HeaderComponent = headerDefinition;
        return {
            component: <HeaderComponent />
        };
    }, [headerDefinition]);

    return (
        <div css={headerColumnCell}>
            <span style={{height}} css={headerCell} onClick={onClick}>
                {component}
            </span>
        </div>
    );
};

RowHeader.IconWrapper = RowHeaderIconWrap;
RowHeader.Title = RowHeaderTitle;

const isHeaderDefinitionObject = (headerDefinition: IComparisonTableHeader): headerDefinition is IComparisonTableHeaderObject => {
    return "label" in headerDefinition && !!headerDefinition.label;
};

const headerColumnCell = css`
    display: flex;
    align-items: center;
    background-color: #fff;
    z-index: 2;
    user-select: none;
`;

const headerCell = (theme: Theme) => css`
    position: absolute;
    left: 0;
    ${p(1, 1, 1, 2)}
    width: ${HEADER_CELL_WIDTH_MOBILE};
    min-width: ${HEADER_CELL_WIDTH_MOBILE};
    display: flex;
    align-items: center;

    @media (min-width: ${theme.breakpoints.md}) {
        width: ${HEADER_CELL_WIDTH};
        min-width: ${HEADER_CELL_WIDTH};
    }
`;
